(function () {
	'use strict';

	// Was created because of IE bug
	// https://stackoverflow.com/questions/32176130/angular-update-input-value-on-enter-keypress-and-work-in-ie/32949801#32949801

	angular.module('mx.components').directive('mxUpdateOnEnter', [
		function mxUpdateOnEnterDirective() {
			return {
				restrict: 'A',
				priority: -10,
				require: 'ngModel',
				link: function (scope, element, attrs, ctrl) {
					element.bind('keydown', function (ev) {
						if (ev.keyCode === 13) {
							ctrl.$commitViewValue();
							scope.$apply(function () {
								ctrl.$setTouched();
							});
						}
					});
				},
			};
		},
	]);
})();
